import { getNavigator } from "@faire/web/common/globals/getNavigator";
import { UAParser } from "ua-parser-js";

export const isTabletDevice = () => {
  const userAgent = getNavigator()?.userAgent;
  if (!userAgent) {
    return false;
  }
  return UAParser(userAgent)?.device?.type === "tablet";
};
